export const schemas = {
    page: {
        dataConfig: {
            'slug': {
                bolt: 'slug',
                lang: false
            },
            'titel': {
                bolt: 'title',
                lang: true
            },
            'body': {
                bolt: 'body',
                lang: true
            }
        }
    }
}

export const fetchConfig = {
    // Muster für individuelles Datenschema
    themesPage: {
        endpoint: 'themenseite',
        data: 'subjectsPageData',
        dataConfig: {
            'slug': {
                bolt: 'slug',
                lang: false
            },
            'titel': {
                bolt: 'title',
                lang: true
            },
            'einleitung': {
                bolt: 'einleitung',
                lang: true
            }
        }
    },
    // Muster für Datenschema
    videosPage: {
        endpoint: 'seiten/videos',
        data: 'videosPageData',
        schema: 'page'
    },
    ethnographicaPage: {
        endpoint: 'seiten/ethnographica',
        data: 'ethnographicaPageData',
        schema: 'page'
    },
    booksPage: {
        endpoint: 'seiten/buecher',
        data: 'booksPageData',
        schema: 'page'
    },
    booksPage: {
        endpoint: 'seiten/buecher',
        data: 'booksPageData',
        schema: 'page'
    },
    fotosPage: {
        endpoint: 'seiten/fotos',
        data: 'fotosPageData',
        schema: 'page'
    },
    dossiersPage: {
        endpoint: 'seiten/dossiers',
        data: 'dossiersPageData',
        schema: 'page'
    },
    digitalLibraryPage: {
        endpoint: 'seiten/digitale-bibliothek',
        data: 'digLibPageData',
        schema: 'page'
    }



}